import { Suspense, ComponentType } from 'react'
import Loader from './Loader'

export default function Loadable<T extends Record<string, unknown>>(
  Component: ComponentType<T>,
): ComponentType<T> {
  function WrappedComponent(props: T) {
    return (
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    )
  }
  return WrappedComponent
}
